var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleInterviews({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53301 1.33337C4.09118 1.33337 3.73301 1.69155 3.73301 2.13337V2.93337H2.93301C2.04935 2.93337 1.33301 3.64972 1.33301 4.53337V12.5334C1.33301 13.417 2.04935 14.1334 2.93301 14.1334H12.533C13.4167 14.1334 14.133 13.417 14.133 12.5334V4.53337C14.133 3.64972 13.4167 2.93337 12.533 2.93337H11.733V2.13337C11.733 1.69155 11.3748 1.33337 10.933 1.33337C10.4912 1.33337 10.133 1.69155 10.133 2.13337V2.93337H5.33301V2.13337C5.33301 1.69155 4.97484 1.33337 4.53301 1.33337ZM4.53301 5.33337C4.09118 5.33337 3.73301 5.69155 3.73301 6.13337C3.73301 6.5752 4.09118 6.93337 4.53301 6.93337H10.933C11.3748 6.93337 11.733 6.5752 11.733 6.13337C11.733 5.69155 11.3748 5.33337 10.933 5.33337H4.53301Z",
    fill: "#393B46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleInterviews);
export default __webpack_public_path__ + "static/media/multiple-interviews.64451412b1011570a46aeaaac6d4ecbd.svg";
export { ForwardRef as ReactComponent };